import script from "./mixResize.vue?vue&type=script&lang=js"
export * from "./mixResize.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__